import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { InquiryHeaderTitle } from '../molecules/InquiryHeaderTitle';
import { useRootStore } from '../../App';

//TODO: almost same style as InquiryDetailHeader..
const StyledSection = styled.section`
  background: #ffffff;
  text-align: left;
  position: relative;
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? `color: #333333;
      font-size: 20px;
      line-height: normal;
      padding-top: 10px;
      padding-bottom: 10px;
      padding-right: 13px;`
      : `border-top: solid 1px #e2e2e2;
      padding: 16px 16px;`}
`;

export const InquiryListHeader = observer(() => {
  const root = useRootStore();
  const { isWide } = root.layoutStore;

  return (
    <StyledSection isWide={isWide}>
      <InquiryHeaderTitle isWide={isWide}>問い合わせ一覧</InquiryHeaderTitle>
    </StyledSection>
  );
});
